import { Tooltip } from '@chakra-ui/react';
import * as React from 'react';

import { SubtleSwitch } from '@/imports/ui/chakra/components/SubtleSwitch';
import { InfoIcon } from '@/imports/ui/chakra/feather';

export type SendEmailInvitesProps = {
  shouldSendEmailInvites: boolean;
  setShouldSendEmailInvites: (value: boolean) => void;
};

export const SendEmailInvites: React.FC<SendEmailInvitesProps> = ({
  shouldSendEmailInvites,
  setShouldSendEmailInvites,
}) => {
  return (
    <SubtleSwitch
      isChecked={shouldSendEmailInvites}
      onChange={(event) => setShouldSendEmailInvites(event.target.checked)}
    >
      Automatically Send Invite Emails to Newly Added Users
      <Tooltip label="You will be able to send them invite emails later via the manage people page.">
        <InfoIcon color="gray.500" ml="2" />
      </Tooltip>
    </SubtleSwitch>
  );
};
